import { SERVER_API_PATH } from "api/api-constants";
import { serverApi } from "api/api-server-actions";
import { RubricType } from "components/server-types";
import { withApiErrorReporting } from "utils/api-errors";

export type ExportedOutcome = {
  title: string;
  description: string;
  rubric_descriptions: string[] | null;
};

export type ExportedOutcomeSubgroup = {
  title: string;
  outcomes: ExportedOutcome[];
};

export type ExportedOutcomeGroup = {
  title: string;
  outcomes: ExportedOutcome[];
  subgroups: ExportedOutcomeSubgroup[];
};

export type OutcomeExportFile = {
  version: 1;
  source_organization_name: string;
  rubric: RubricType;
  groups: ExportedOutcomeGroup[];
};

export type OutcomeImportPreview = {
  outcome_export_file: OutcomeExportFile;
  import_token: string;
  rubric_mismatch: boolean;
};

type OutcomeTransferAction = "export" | "preview" | "import";

function serverOutcomeTransferRequest<T>(
  action: OutcomeTransferAction,
  orgId: string,
  requestBody: object,
  signal: AbortSignal,
): Promise<T> {
  return withApiErrorReporting(`outcomeTransfer:${action}`, async () => {
    const response = await serverApi.post<T>(
      `${SERVER_API_PATH}/material/outcome_transfer/${action}/`,
      { ...requestBody, org_id: orgId },
      { signal, timeout: 60000 },
    );
    return response.data;
  });
}

export const serverExportOutcomeTree = (
  orgId: string,
  outcomeGroupIds: string[],
  signal: AbortSignal,
) =>
  serverOutcomeTransferRequest<OutcomeExportFile>(
    "export",
    orgId,
    { group_ids: outcomeGroupIds },
    signal,
  );

export const serverPreviewOutcomeImport = (
  orgId: string,
  outcomeExportData: unknown,
  signal: AbortSignal,
) =>
  serverOutcomeTransferRequest<OutcomeImportPreview>(
    "preview",
    orgId,
    { outcome_export_file: outcomeExportData },
    signal,
  );

export const serverImportOutcomeTree = (orgId: string, importToken: string, signal: AbortSignal) =>
  serverOutcomeTransferRequest<{ count: number }>(
    "import",
    orgId,
    { import_token: importToken },
    signal,
  );
